import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class ProviderSettlementModel extends BaseModel {
  static urlPath = "provider_settlement";

  @attr("number") provider;
  @attr("number") case;
  @attr("string") initialAmount;
  @attr("string") settledAmount;
  @attr("string") status;
  @attr("string") discount;
  @attr("number") settlementType;
  @attr("string") providerName;
  @attr("boolean") hasCheck;
  @attr("number") providerEntityId;
  @attr("string") includedInReduction;
  @attr("boolean") providerInNetwork;
  @attr("string") depositDate;
  @attr("string") cnbDepositDate;
  @attr("string") batchNumber;
  @attr("string") receivable;
  @attr("string") notes;
}
